module.exports = __webpack_public_path__ + "static/media/launch.c2998b73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/launch.png
// module id = 221
// module chunks = 0